import React, { createContext, useContext, useEffect } from 'react';
import { AlertModalManager } from '../components/AlertModalManager';
import { useAlertModal } from '../hooks/useAlertModal';
import { AlertModalContextType, AlertModalProviderProps } from '../types';

const AlertModalContext = createContext<AlertModalContextType | undefined>(undefined);

export const useAlertModalContext = () => {
  const context = useContext(AlertModalContext);
  if (!context) {
    throw new Error('useAlertModalContext must be used within AlertModalProvider');
  }
  return context;
};

export const AlertModalProvider: React.FC<AlertModalProviderProps> = ({ children }) => {
  const { isOpen, modalContent, openModal, closeModal } = useAlertModal();

  useEffect(() => {
    const handleOpenModal = (event: CustomEvent) => {
      openModal(event.detail);
    };

    window.addEventListener('openAlertModal', handleOpenModal as EventListener);

    return () => {
      window.removeEventListener('openAlertModal', handleOpenModal as EventListener);
    };
  }, [openModal]);

  return (
    <AlertModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <AlertModalManager modalContent={modalContent} isOpen={isOpen} onClose={closeModal} />
    </AlertModalContext.Provider>
  );
};
